// extracted by mini-css-extract-plugin
export default {"button":"ScrollToBottom_button__OJY6d"};